var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrossError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2808_69771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0C9.89323 0 0.5 9.39233 0.5 21C0.5 32.6068 9.89233 42 21.5 42C33.1068 42 42.5 32.6077 42.5 21C42.5 9.39315 33.1077 0 21.5 0ZM21.5 38.7188C11.7068 38.7188 3.78125 30.794 3.78125 21C3.78125 11.2067 11.706 3.28125 21.5 3.28125C31.2932 3.28125 39.2188 11.206 39.2188 21C39.2188 30.7933 31.294 38.7188 21.5 38.7188Z",
    fill: "#FF4B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6851 25.8649L23.8205 21.0003L28.6851 16.1357C29.3258 15.495 29.3259 14.4563 28.6852 13.8155C28.0444 13.1748 27.0056 13.1749 26.3651 13.8155L21.5004 18.6801L16.6357 13.8155C15.9951 13.1748 14.9561 13.1748 14.3155 13.8155C13.6748 14.4563 13.6748 15.495 14.3156 16.1357L19.1802 21.0003L14.3156 25.8649C13.6748 26.5057 13.6747 27.5444 14.3155 28.1851C14.9564 28.8259 15.9952 28.8257 16.6357 28.1851L21.5004 23.3205L26.3651 28.1851C27.0056 28.8258 28.0445 28.8258 28.6852 28.1851C29.326 27.5444 29.3259 26.5056 28.6851 25.8649Z",
    fill: "#FF4B62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2808_69771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossError);
export default __webpack_public_path__ + "static/media/icon-cross-error.12ee3c3fd8835a67ff2eec590772acde.svg";
export { ForwardRef as ReactComponent };